import pages from '../../pages';
import * as permissions from '../permissions';

export default [
  { path: '/:realm/account-settings/profile', component: pages.growz.settings },
  { path: '/:realm/account-settings/change-password', component: pages.growz.settings },
  {
    path: '/:realm/store-settings/profile',
    component: pages.growz.settings,
    permission: permissions.PERM_STORE_SETTINGS,
  },
  {
    path: '/:realm/account-settings/notification',
    component: pages.growz.settings,
    permission: permissions.PERM_STORE_SETTINGS,
  },
  {
    path: '/:realm/alerts',
    component: pages.growz.notifications,
    permission: permissions.PERM_STORE_SETTINGS,
  },
  {
    path: '/:realm/store-settings/custom-name',
    component: pages.growz.settings,
    permission: permissions.PERM_STORE_SETTINGS,
  },
  {
    path: '/:realm/store-settings/store-reconnect',
    component: pages.growz.settings,
    permission: permissions.PERM_STORE_SETTINGS,
  },
  { path: '/:realm/notifications', component: pages.growz.notifications },
  { path: '/:realm/success', component: pages.subscription.SuccessPage },

  {
    path: '/:realm/subscription/active-plan',
    component: pages.growz.subscription,
  },

  {
    path: '/:realm/subscription/add-ons',
    component: pages.growz.subscription,
  },

  {
    path: '/:realm/subscription/invoices',
    component: pages.growz.subscription,
  },

  {
    path: '/:realm/subscription/usage',
    component: pages.growz.subscription,
  },

  {
    path: '/:realm/sellergpt',
    component: pages.sellergpt.Main,
  },

  // for testing only
  { path: '/:realm/test', component: pages.testPage },
];
